import { Box, Button, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import CreateModal from "./common/Modal/Modal";
import CreateInput from "./common/TextInputs/Input";
import { addLanguage, updateLanguage } from "../utils/api";

const LanguageModal = ({ title, update, reload }) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = React.useState(false);
  const [language, setLanguage] = React.useState({
    name: "",
  });
  const createLanguage = async () => {
    if (language.name === "") {
      toast({
        title: "Error",
        description: "Please enter name",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
      return;
    }
    setLoading(true);
    if (!update) {
      const [success, data] = await addLanguage(language);
      if (success) {
        toast({
          title: "Language Added",
          description: "Language Added Successfully",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        reload();
        onClose();
        setLanguage({ name: "" });
      } else {
        const errorMessage = 
          data?.response?.data?.message || 
          data?.message || 
          data?.response?.data?.error ||
          (typeof data === 'string' ? data : 'Failed to add language');
        toast({
          title: "Error",
          description: errorMessage,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    } else {
      const [success, data] = await updateLanguage(update._id, language);
      if (success) {
        toast({
          title: "Language Updated",
          description: "Language Updated Successfully",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
        reload();
        onClose();
      } else {
        const errorMessage = 
          data?.response?.data?.message || 
          data?.message || 
          data?.response?.data?.error ||
          (typeof data === 'string' ? data : 'Failed to update language');
        toast({
          title: "Error",
          description: errorMessage,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (update) {
      setLanguage({
        name: update.name,
      });
    } else {
      setLanguage({ name: "" });
    }
  }, [update, isOpen]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Button
        colorScheme="blue"
        variant="solid"
        onClick={onOpen}
        sx={{
          width: "100%",
        }}
      >
        {title}
      </Button>
      <CreateModal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        create={createLanguage}
        isLoading={loading}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <CreateInput
            name="Name"
            onChange={(e) => {
              setLanguage({ ...language, name: e.target.value });
            }}
            value={language?.name}
          />
        </Box>
      </CreateModal>
    </Box>
  );
};

export default LanguageModal;

